import React from "react";
import styles from "./BottomBar.module.css";

export default function BottomBar({ pageCount, panelCount, saveState }) {
  return (
    <footer className={styles.bar}>
      <span className={`${styles.item} text-label-sm`}>
        <span className="material-symbols-outlined" style={{ fontSize: 14 }}>
          auto_stories
        </span>
        {pageCount} {pageCount === 1 ? "página" : "páginas"}
      </span>
      <span className={styles.divider}>|</span>
      <span className={`${styles.item} text-label-sm`}>
        <span className="material-symbols-outlined" style={{ fontSize: 14 }}>
          image
        </span>
        {panelCount} {panelCount === 1 ? "frame" : "frames"}
      </span>

      <div className={styles.spacer} />

      <span className={`${styles.item} text-label-sm ${styles.status}`}>
        <span
          className={`${styles.statusDot} ${
            saveState === "saving" ? styles.statusDotBusy : ""
          }`}
        />
        {saveState === "saving" ? "Guardando…" : "Autoguardado activo"}
      </span>
    </footer>
  );
}
